import VideoGridPage from '../components/VideoGridPage';

const SECTIONS_PRIERES = [
  { key: 'byPrieres', label: 'PRIÈRES PAR ANNÉE', renderKey: 'byYear' },
  { key: 'byPrieresTheme', label: 'PRIÈRES PAR THÈME', renderKey: 'byTheme' },
];

export default function PrieresPage() {
  return (
    <VideoGridPage
      section="prieres"
      sidebarLabel="PRIÈRES PAR ANNÉE"
      renderKey="byYear"
      videoTitlePrefix={null}
      showThemeFilter={true}
      multipleVideosPerDay={true}
      extraSections={SECTIONS_PRIERES}
    />
  );
}